import MultipartFileUploadDispatcherFactory from './MultipartFileUploadDispatcherFactory';
import { IMultipartFileUploadDispatcherFactoryMethod as IMultipartFileUploadDispatcherFactory } from './interfaces';
import { DIUploadTypes } from '../types';

export const { MultipartFileUploadDispatcher } = DIUploadTypes;

export type { IMultipartFileUploadDispatcherFactory };

export default MultipartFileUploadDispatcherFactory;
